import React from 'react';
import {
  Brain,
  Bot,
  Cloud,
  Clock,
  Wrench,
  Rocket,
  Users,
  Target,
  BookOpen,
  Headphones,
  Dna,
  Mic,
  Flag,
  Shuffle,
  Camera,
  Search,
  Lock,
  FlaskConical,
  SlidersHorizontal,
  Zap,
  Shield,
  Compass,
  BarChart3,
  Puzzle,
  Database,
  Package,
  FolderOpen,
  PenLine,
  GraduationCap,
  Handshake,
  Laptop,
  CheckCircle2,
  TrendingUp,
} from 'lucide-react';

// Content (YAML) can only reference icons by name — this maps those names
// back to the actual Lucide components. Add new icons here as new YAML
// content needs them.
export const ICONS = {
  Brain,
  Bot,
  Cloud,
  Clock,
  Wrench,
  Rocket,
  Users,
  Target,
  BookOpen,
  Headphones,
  Dna,
  Mic,
  Flag,
  Shuffle,
  Camera,
  Search,
  Lock,
  FlaskConical,
  SlidersHorizontal,
  Zap,
  Shield,
  Compass,
  BarChart3,
  Puzzle,
  Database,
  Package,
  FolderOpen,
  PenLine,
  GraduationCap,
  Handshake,
  Laptop,
  CheckCircle2,
  TrendingUp,
};

export const DataIcon = ({ name, ...props }) => {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return <Icon aria-hidden="true" {...props} />;
};

export default ICONS;
